<template>
  <div id="app">
		
		<img id="logo" src="./assets/apart2play_logo.png">
		
		<div class="content">
			<p class="summary">We offer private music lessons in your own home,<br/>in central and southern Maryland.</p>
			<div class="instruments">
				<div>Our teachers offer instruction on the following instruments:</div>
				<div class="gw-row center-h">
					<ul class="instrument-column">
						<li v-for="(instrument, i) in instruments" :key="i" class="instrument">{{ instrument }}</li>
					</ul>
					<!-- <ul class="instrument-column">
						<li v-for="(instrument, i) in instrumentsRight" :key="i" class="instrument">{{ instrument }}</li>
					</ul> -->
				</div>
			</div>
			<div class="contact">
				<p>Questions? Contact us by phone or email.
					<br />
					Phone #: <a href="tel:4109695789">(410) 969-5789</a>
					<br />
					Email: <a href="mailto:apart2play@gmail.com">apart2play@gmail.com</a>
				</p>
			</div>
		</div>
		
  </div>
</template>

<script>

export default {
	
	name: 'App',
	
  data() {
    return {
			instruments: ['Piano','Harp','Flute','Clarinet','Saxophone','Trumpet','Trombone','Voice']
			// instrumentsLeft: ['Piano','Flute','Clarinet','Saxophone'],
			// instrumentsRight: ['Harp','Trumpet','Trombone','Voice']
    };
	},
	
	created() {
	},
	
	destroyed() {
	},
	
  methods: {
  }
}
</script>
